import "./css/_notificationbar.scss";
import "./css/_preview.scss";
import domtoimage from "dom-to-image-more";

try {
    document.getElementById("maglr-preview-btn")?.addEventListener("click", () => {
        let element = document.getElementById("maglr-preview-bar");
        if (element) {
            element.classList.add("collapsed");
        }
    });
    document.getElementById("previewTipExpand")?.addEventListener("click", () => {
        let element = document.getElementById("maglr-preview-bar");
        if (element) {
            element.classList.remove("collapsed");
        }
    });

    document.getElementById("maglr-add-btn")?.addEventListener("click", () => {
        let element = document.getElementById("maglr-add-bar");
        if (element) {
            element.style.opacity = 0;
            setTimeout(() => {
                element.style.display = "none";
            }, 300);
        }
    });

    document.getElementById("buttonSharePreview")?.addEventListener("click", () => {
        let element = document.getElementById("sharePreviewLinkOverlay");
        if (element) {
            element.classList.add("open");
        }
    });

    document.getElementById("sharePreviewClose")?.addEventListener("click", () => {
        let element = document.getElementById("sharePreviewLinkOverlay");
        if (element) {
            element.classList.remove("open");
        }
    });

    document.getElementById("sharePreviewCopy")?.addEventListener("click", (event) => {
        let element = document.getElementById("sharePreviewLink");
        if (element) {
            element.select();
            document.execCommand("Copy");
            element.classList.add("copied");
            event.target?.focus?.();
        }
    });

    if (window !== window.top) {
        window.addEventListener("message", (event) => {
            if (
                event.origin === window.location.protocol + "//" + window.location.host &&
                event.data !== undefined &&
                event.data.message !== undefined
            ) {
                console.log("message " + event.data.message, event, window.spread_id, typeof window.spread_id);
                let element;
                switch (event.data.message) {
                    case "COMMENTS_STARTED":
                        element = document.getElementById("maglr-preview-bar");
                        if (element) {
                            element.classList.add("collapsed", "hide-for-comments");
                        }
                        break;
                    case "REQUEST_SPREAD_INFO":
                        console.log("SPREAD_INFO message", event, window.spread_id, typeof window.spread_id);
                        event.source.postMessage(
                            {
                                message: "SPREAD_INFO",
                                issue_id: window.issue_id,
                                spread_id: window.spread_id,
                                issue: window.frontend?.dataHelper?.issues[window.issue_id] || window.issue,
                            },
                            event.origin,
                        );
                        break;
                    case "SCENE_STARTED":
                        window.top.postMessage(
                            { message: "SCENE_INFO", issue_id: window.issue_id, scene_id: event.data.scene_id },
                            event.origin,
                        );
                        break;
                    case "SPREAD_NAVIGATION":
                        UuidSelection.clear(true);
                        UuidSelection.stop();
                        console.log(
                            "SPREAD_NAVIGATION message",
                            event,
                            event.data.spread_id,
                            typeof event.data.spread_id,
                        );
                        window.top.postMessage(
                            {
                                message: "SPREAD_INFO",
                                issue_id: event.data.issue_id,
                                spread_id: event.data.spread_id,
                            },
                            event.origin,
                        );
                        window.top.postMessage(
                            {
                                message: "SPREAD_NAVIGATION",
                                issue_id: event.data.issue_id,
                                spread_id: event.data.spread_id,
                            },
                            event.origin,
                        );
                        break;
                    case "PAGE_READY":
                        console.log(
                            "PAGE_READY message",
                            event,
                            event.data.origin_spread_id,
                            typeof event.data.origin_spread_id,
                        );
                        window.top.postMessage(
                            {
                                message: "PAGE_READY",
                                issue_id: event.data.issue_id,
                                spread_id: event.data.origin_spread_id,
                            },
                            event.origin,
                        );
                        break;
                    case "START_UUID_SELECTION":
                        UuidSelection.start();
                        break;
                    case "STOP_UUID_SELECTION":
                        UuidSelection.stop();
                        break;
                    case "HIGHLIGHT_UUID":
                        console.log("HIGHLIGHT_UUID message", event.data.task_id, event.data.uuid, event.data.spreadId);
                        UuidSelection.highlightUuid(event.data);
                        break;
                    case "POINT_UUID_SELECTION":
                        console.log("POINT_UUID_SELECTION message", event.data.uuid);
                        UuidSelection.pointByElementId(event.data.uuid);
                        break;
                    case "CLEAR_UUID_SELECTION":
                        UuidSelection.clear(true);
                        break;
                    case "REQUEST_SCREENSHOT":
                        console.log("REQUEST_SCREENSHOT message", event.data);
                        ScreenshotHandler.takeScreenshot(event);
                        break;
                }
            }
        });
    }

    const UuidSelection = {
        clickedElement: null,
        hoverElements: [],
        cursor: null,
        start: function () {
            console.log("UuidSelection.start");
            const iframeDoc = window.document;
            UuidSelection.cursor = iframeDoc.body.style.cursor;
            iframeDoc.body.style.cursor = "pointer";
            iframeDoc.addEventListener("click", UuidSelection.handleClickedElement, true);

            var allElements = document.querySelectorAll("*");
            allElements.forEach((element) => {
                if (element.id && element.id.startsWith("uuid_")) {
                    element.classList.add("comment-select-hover");
                }
            });
        },
        stop: function () {
            console.log("UuidSelection.stop");
            const iframeDoc = window.document;
            iframeDoc.body.style.cursor = UuidSelection.cursor || "auto";
            iframeDoc.removeEventListener("click", UuidSelection.handleClickedElement, true);

            document
                .querySelectorAll(".comment-select-hover")
                .forEach((e) => e.classList.remove("comment-select-hover"));
        },
        highlightUuid: function (data) {
            console.log("highlightUuid", data);
            window.postMessage({ ...data, message: "HIGHLIGHT_ELEMENT" });
            window.top.postMessage({ message: "SELECTED_UUID", uuid: data.uuid });
        },
        pointByElementId: function (data) {
            console.log("UuidSelection.pointByElementId", data);
            const element = window.document.getElementById(data);
            if (element === null) {
                UuidSelection.clear(true);
                return;
            }
            UuidSelection.clear();
            UuidSelection.point(element);
            window.top.postMessage({ message: "SELECTED_UUID", uuid: data });
            if (!UuidSelection.isInViewport(element)) {
                UuidSelection.scrollToElement(element);
            }
        },
        point: function (element) {
            UuidSelection.clickedElement = { element };
            UuidSelection.clickedElement.element.classList.add("comments-selected-uuid");
        },
        clear: function (sendMessage = false) {
            if (UuidSelection.clickedElement != null) {
                UuidSelection.clickedElement.element.classList.remove("comments-highlight", "comments-selected-uuid");
            }
            if (sendMessage) {
                window.top.postMessage({ message: "SELECTED_UUID", uuid: null });
            }
            document.querySelectorAll(".comments-highlight").forEach((e) => e.classList.remove("comments-highlight"));
        },
        handleClickedElement: function (event) {
            event.stopPropagation();
            event.preventDefault();
            let clickedElement = event.target;
            if (!clickedElement.id || !clickedElement.id.startsWith("uuid_")) {
                clickedElement = event.target.closest(".element");
            }
            if (clickedElement) {
                UuidSelection.clear();
                UuidSelection.point(clickedElement);
                window.top.postMessage({
                    message: "SELECTED_UUID",
                    uuid: clickedElement.id,
                    spreadId: window.spread_id,
                    title: clickedElement.dataLabel,
                });
            } else {
                console.log("No element found");
                UuidSelection.clear(true);
            }
        },
        isInViewport: function (element) {
            if (!element) {
                return false;
            }
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        scrollToElement: function (element) {
            element.scrollIntoView({ behavior: "smooth", block: "center" });
        },
    };

    const ScreenshotHandler = {
        async takeScreenshot(event) {
            try {
                const { format = "png", quality = 0.9 } = event.data;

                let captureElement = document.body;

                const spreadElement = document.querySelector(".maglrspread");
                const currentSpread = document.querySelector(".current-spread");
                const spreadContainer = document.querySelector(".spread-container.shown");

                if (currentSpread) {
                    captureElement = currentSpread;
                } else if (spreadElement) {
                    captureElement = spreadElement;
                } else if (spreadContainer) {
                    captureElement = spreadContainer;
                }

                const domToImageResult = await this.takeDomToImageScreenshot(
                    captureElement,
                    domtoimage,
                    format,
                    quality,
                );

                event.source.postMessage(
                    {
                        message: "SCREENSHOT_RESPONSE",
                        success: true,
                        screenshot: domToImageResult,
                    },
                    event.origin,
                );
            } catch (error) {
                console.error("MAGLR ERROR: [ScreenshotHandler.takeScreenshot]", error);
                event.source.postMessage(
                    {
                        message: "SCREENSHOT_RESPONSE",
                        success: false,
                        error: error.message,
                    },
                    event.origin,
                );
            }
        },

        async embedFonts() {
            try {
                const styleSheets = Array.from(document.styleSheets);
                const fontFaces = [];

                for (const styleSheet of styleSheets) {
                    try {
                        if (styleSheet.href && styleSheet.href.includes("localhost")) {
                            const rules = Array.from(styleSheet.cssRules || styleSheet.rules || []);
                            for (const rule of rules) {
                                if (rule.type === CSSRule.FONT_FACE_RULE) {
                                    fontFaces.push(rule.cssText);
                                }
                            }
                        }
                    } catch {
                        // Skip inaccessible stylesheets
                    }
                }

                if (fontFaces.length > 0) {
                    const fontStyle = document.createElement("style");
                    fontStyle.textContent = fontFaces.join("\n");
                    fontStyle.setAttribute("data-maglr-embedded-fonts", "true");
                    document.head.appendChild(fontStyle);

                    if (document.fonts && document.fonts.ready) {
                        await document.fonts.ready;
                    }
                }
            } catch {
                // Ignore font embedding errors
            }
        },

        async takeDomToImageScreenshot(element, domtoimage, format, quality) {
            await this.embedFonts();

            const scrollX = window.scrollX || window.pageXOffset || 0;
            const scrollY = window.scrollY || window.pageYOffset || 0;
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;

            const rect = element.getBoundingClientRect();
            const fullWidth = rect.width || element.scrollWidth || document.documentElement.scrollWidth;
            const fullHeight = rect.height || element.scrollHeight || document.documentElement.scrollHeight;

            const options = {
                quality: quality,
                width: fullWidth,
                height: fullHeight,
                style: {
                    transform: "scale(1)",
                    transformOrigin: "top left",
                    width: fullWidth + "px",
                    height: fullHeight + "px",
                },
                useCORS: true,
                allowTaint: true,
                imagePlaceholder: undefined,
                cacheBust: true,
                skipFonts: false,
                embedFonts: true,
                inlineFonts: true, // Force inline font embedding
                fontEmbedCSS: true, // Embed CSS font rules
                filter: (node) => {
                    if (node.tagName === "STYLE" || node.tagName === "LINK") {
                        return true;
                    }
                    return true;
                },
            };

            let dataUrl;

            if (format === "jpeg") {
                dataUrl = await domtoimage.toJpeg(element, options);
            } else {
                dataUrl = await domtoimage.toPng(element, options);
            }

            return new Promise((resolve, reject) => {
                const img = new Image();
                img.onload = () => {
                    const outputCanvas = document.createElement("canvas");
                    outputCanvas.width = viewportWidth;
                    outputCanvas.height = viewportHeight;
                    const outputCtx = outputCanvas.getContext("2d");

                    const cropX = scrollX;
                    const cropY = scrollY;

                    const cropWidth = viewportWidth;
                    const cropHeight = viewportHeight;

                    const safeCropX = Math.min(cropX, Math.max(0, img.width - cropWidth));
                    const safeCropY = Math.min(cropY, Math.max(0, img.height - cropHeight));
                    const safeCropWidth = Math.min(cropWidth, img.width - safeCropX);
                    const safeCropHeight = Math.min(cropHeight, img.height - safeCropY);

                    outputCtx.drawImage(
                        img,
                        safeCropX,
                        safeCropY,
                        safeCropWidth,
                        safeCropHeight, // Source crop area
                        0,
                        0,
                        viewportWidth,
                        viewportHeight, // Destination (full output canvas)
                    );

                    const resizedCanvas = this.resizeCanvas(outputCanvas, 1500, 1500);
                    const finalDataUrl = resizedCanvas.toDataURL(
                        `image/${format}`,
                        format === "jpeg" ? quality : undefined,
                    );

                    resolve(finalDataUrl);
                };

                img.onerror = () => {
                    reject(new Error("Failed to process dom-to-image result"));
                };

                img.src = dataUrl;
            });
        },

        resizeCanvas(sourceCanvas, maxWidth = 1500, maxHeight = 1500) {
            const originalWidth = sourceCanvas.width;
            const originalHeight = sourceCanvas.height;

            const scaleX = maxWidth / originalWidth;
            const scaleY = maxHeight / originalHeight;
            const scale = Math.min(scaleX, scaleY, 1);

            if (scale >= 1) return sourceCanvas;

            const newWidth = Math.floor(originalWidth * scale);
            const newHeight = Math.floor(originalHeight * scale);

            const resizedCanvas = document.createElement("canvas");
            resizedCanvas.width = newWidth;
            resizedCanvas.height = newHeight;
            const resizedCtx = resizedCanvas.getContext("2d");

            resizedCtx.imageSmoothingEnabled = true;
            resizedCtx.imageSmoothingQuality = "high";
            resizedCtx.drawImage(sourceCanvas, 0, 0, newWidth, newHeight);

            return resizedCanvas;
        },
    };
} catch (error) {
    console.error("MAGLR ERROR: [preview]", error);
}
